(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/nav-menu/assets/javascripts/oddset-nav-item.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/nav-menu/assets/javascripts/oddset-nav-item.js');
"use strict";


const {
  Link
} = ReactRouterDOM;
const {
  IconItem
} = svs.ui.ReactItemsMenu;
const {
  navigateTo
} = svs.oddset_kambi.components.wapiIntegration;
const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
const {
  MenuTabTypes
} = svs.oddset_kambi.components.common.constants;
const moduleBaseUrl = svs.core.data.baseUrl;
const onTabClick = (clickEvent, route, currentRoute) => {
  if (route.isPlayRoute) {
    if (!isLoggedIn && route.tabType === MenuTabTypes.MyBets) {
      svs.components.customer_login.login();
      return;
    }
    navigateTo("/".concat(route.path));
    if (currentRoute.isPlayRoute) {
      clickEvent.preventDefault();
    }
  }
  const header = document.getElementById('top-content');
  const h1Image = (header === null || header === void 0 ? void 0 : header.querySelectorAll('.brand-brand')) || [];
  if (h1Image.length) {
    h1Image.forEach(productImage => {
      if (productImage) {
        productImage.setAttribute('alt', (route === null || route === void 0 ? void 0 : route.logotypeAltText) || 'Oddset');
      }
    });
  }
};
const OddsetNavItem = _ref => {
  let {
    route,
    renderMobileMenu,
    isSelected,
    currentRoute,
    badge = null
  } = _ref;
  const target = "/".concat(route.path);
  const href = route.isExternalRoute ? "/".concat(route.path) : "".concat(moduleBaseUrl).concat(target);
  return React.createElement(IconItem, {
    alignment: renderMobileMenu ? 'vertical' : 'horizontal',
    badge: badge,
    className: "oddset-nav__link",
    Component: route.isExternalRoute ? 'a' : Link,
    "data-testid": "oddset-route",
    gutter: 1,
    href: href,
    iconName: route.icon ? route.icon : 'play-circle',
    isSelected: isSelected,
    key: route.path,
    label: renderMobileMenu && route.shortLabel || route.label,
    onClick: event => onTabClick(event, route, currentRoute),
    to: target
  });
};
setGlobal('svs.oddset_kambi.components.nav_menu.OddsetNavItem', OddsetNavItem);

 })(window);